import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';;
var loading = function loading(message) {
  if (!Loading.isActive) {
    return Loading.show({
      message: message,
      backgroundColor: "white",
      customClass: "loading-class",
      spinnerColor: "primary",
      messageColor: "black"
    });
  }
};
export default {
  name: "login",
  data: function data() {
    return {
      clienteId: "",
      password: "",
      windowWidth: window.innerWidth,
      isDesktop: false,
      isBloqueado: false,
      isLoading: false,
      requestService: new RequestService(),
      messageError: ""
    };
  },
  methods: {
    validatePassword: function validatePassword() {
      if (this.password != "") {
        return true;
      }
      return false;
    },
    validateClientId: function validateClientId() {
      if (this.clienteId != "") {
        // SGH-21091
        if (isNaN(this.clienteId)) {
          return false;
        }
        this.clienteId = parseInt(this.clienteId).toString();
        //
        return true;
      }
      return false;
    },
    login: function login() {
      var _this = this;
      if (this.validateClientId() && this.validatePassword()) {
        loading("<h5>Autenticando...</h5>");
        this.requestService.loginClient(this.clienteId, this.password).then(function (res) {
          if (res.data.auth) {
            localStorage.setItem("painel-web-auth-token", res.data.token);
            _this.$router.push("/".concat(_this.clienteId, "/paineis"));
          } else {
            _this.showError(res.data.message);
            localStorage.removeItem("painel-web-auth-token");
          }
        }).catch(function (_ref) {
          var data = _ref.data;
          _this.showError(data.message);
        });
      }
    },
    showError: function showError(msg) {
      Loading.hide();
      Notify.create({
        color: "negative",
        type: "warning",
        textColor: "white",
        message: msg,
        position: "top"
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    if (this.$route.query.q) {
      this.showError(this.$route.query.q);
    }
    if (this.windowWidth > 600) this.isDesktop = true;
    window.onresize = function () {
      _this2.windowWidth = window.innerWidth;
      if (_this2.windowWidth > 600) _this2.isDesktop = true;else _this2.isDesktop = false;
    };
    if (this.$route.params.cliente) {
      this.isBloqueado = true;
      this.clienteId = this.$route.params.cliente;
    }
  },
  updated: function updated() {
    this.$nextTick(function () {
      if (this.$route.query.q != null) {
        this.$router.push({
          path: "/",
          query: {
            q: null
          }
        });
      }
    });
  }
};